<!-- src/views/LoadingPage.vue -->
<template>
  <div class="loading-page">
    <div class="ask-ai-page">
      <!-- Top bar header -->
      <header class="header">
        <div class="logo">
          <img src="@/assets/taxscanai-logo.png" alt="Taxscan Logo" />
        </div>
        <button class="logout-button" @click="logout">
          <span class="desktop-label">Signout</span>
          <span class="mobile-label">S</span>
        </button>
      </header>

      <!-- Optional: brand illustration or icon -->
      <!-- <img src="@/assets/ai-illustration.svg" alt="AI Illustration" class="brand-illustration" /> -->

      <h1>{{ currentLoadingMessage }}<span class="dots">{{ animatedDots }}</span></h1>
      <p class="subheading">Please wait while we process your request…</p>

      <!-- Animated spinner -->
      <div class="loading-animation"></div>

      <!-- Optional: Cancel button if you want to allow users to abort -->
      <!-- <button class="cancel-button" @click="cancelOperation">Cancel</button> -->
    
      </div>
      <footer class="footer">
        <p>© {{ new Date().getFullYear() }} Taxscan Edutech Private Limited. All rights reserved.</p>
      </footer>

    </div>

</template>

<script>
export default {
  name: 'LoadingPage',
  data() {
    return {
      currentLoadingMessage: '🤖 AI is thinking',
      animatedDots: '',
      dotsInterval: null,
      messageInterval: null,
      loadingMessages: [
        "🤖 AI is thinking",
        "🔍 Searching for insights",
        "📊 Analyzing data",
        "📚 Looking up references",
        "⚡ Generating the best response",
        "🤯 Processing complex information",
        "🔄 Summarizing findings",
      ],
    };
  },
  mounted() {
    this.startLoadingAnimation();
  },
  unmounted() {
    this.stopLoadingAnimation();
  },
  methods: {
    startLoadingAnimation() {
      // Animate dots (..., .., .)
      this.dotsInterval = setInterval(() => {
        this.animatedDots =
          this.animatedDots.length < 3 ? this.animatedDots + "." : "";
      }, 500);

      // Rotate through different loading messages
      this.messageInterval = setInterval(() => {
        this.currentLoadingMessage =
          this.loadingMessages[
            Math.floor(Math.random() * this.loadingMessages.length)
          ];
      }, 2000);
    },
    stopLoadingAnimation() {
      clearInterval(this.dotsInterval);
      clearInterval(this.messageInterval);
    },
    logout() {
      // ✅ Logout function: remove token and redirect
      localStorage.removeItem('auth_token');
      this.$router.push('/');
    },
    // Optional: Cancel or go back if needed
    // cancelOperation() {
    //   // e.g., navigate to home or previous step
    //   this.$router.push('/');
    // }
  },
};
</script>

<style scoped>

.ask-ai-page {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  text-align: center; /* This keeps your main content centered */
  position: relative; /* If you need absolute positioning for the icon, see step 3 */
}

/* A full-screen gradient background for a modern look */
.loading-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  /* Gradient background example (adjust to your brand colors) */
  background: linear-gradient(135deg, #e2f3f5 0%, #ffffff 100%);
  padding: 20px;
  text-align: center;
}

h1 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #333;
}

/* Subheading to reassure the user */
.subheading {
  font-size: 1rem;
  color: #555;
  margin-bottom: 20px;
}

/* The spinner animation */
.loading-animation {
  width: 60px;
  height: 60px;
  margin: 20px auto;
  border: 6px solid rgba(0, 0, 0, 0.1);
  border-left-color: #4caf50; /* Brand color for the spinner */
  border-radius: 50%;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Dots blinking effect */
.dots {
  font-weight: bold;
  animation: blink 1s infinite;
}

@keyframes blink {
  50% {
    opacity: 0.5;
  }
}

/* Optional brand illustration or icon */
.brand-illustration {
  width: 120px;
  height: auto;
  margin-bottom: 20px;
}

/* Optional cancel button */
.cancel-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #dc3545; /* Red color for cancel */
  color: #fff;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
}

.cancel-button:hover {
  background-color: #c82333;
}


.icon-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.icon-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}


.tooltip-text {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 6px 8px;
  position: absolute;
  z-index: 999;
  bottom: 125%; /* Position above the icon */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}


.logout-button {
  background: #007bff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
  transition: background-color 0.3s;
}

.logout-button:hover {
  background: #0056b3;
}

.logout-button .mobile-label {
  display: none;
}

@media (max-width: 768px) {
  .logo img {
    max-height: 40px;
  }
  .logout-button .desktop-label {
    display: none;
  }
  .logout-button .mobile-label {
    display: inline;
  }
  .footer {
    font-size: 11px; /* or any size you prefer for mobile devices */
  }
}


/* Header that spans full width */
.page-header {
  width: 100%;
  display: flex;
  justify-content: flex-end; /* Moves icon to the right */
  align-items: center;
  margin-bottom: 20px;
  /* If you want the header pinned to top, see step 3 for absolute positioning */
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.logo img {
  max-height: 140px;
  transition: max-height 0.3s;
}
</style>
